var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0835 26.5833H16.9168C15.6349 26.5833 14.4056 27.0925 13.4991 27.999C12.5927 28.9054 12.0835 30.1348 12.0835 31.4166V45.9166C12.0835 47.1985 12.5927 48.4279 13.4991 49.3343C14.4056 50.2408 15.6349 50.75 16.9168 50.75H41.0835C42.3654 50.75 43.5948 50.2408 44.5012 49.3343C45.4076 48.4279 45.9168 47.1985 45.9168 45.9166V31.4166C45.9168 30.1348 45.4076 28.9054 44.5012 27.999C43.5948 27.0925 42.3654 26.5833 41.0835 26.5833Z",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0002 41.0833C29.6411 41.0833 30.2558 40.8287 30.709 40.3755C31.1622 39.9223 31.4168 39.3076 31.4168 38.6667C31.4168 38.0257 31.1622 37.411 30.709 36.9578C30.2558 36.5046 29.6411 36.25 29.0002 36.25C28.3592 36.25 27.7445 36.5046 27.2913 36.9578C26.8381 37.411 26.5835 38.0257 26.5835 38.6667C26.5835 39.3076 26.8381 39.9223 27.2913 40.3755C27.7445 40.8287 28.3592 41.0833 29.0002 41.0833V41.0833Z",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3335 26.5833V16.9167C19.3335 14.3529 20.3519 11.8942 22.1648 10.0813C23.9776 8.26845 26.4364 7.25 29.0002 7.25C31.5639 7.25 34.0227 8.26845 35.8355 10.0813C37.6484 11.8942 38.6668 14.3529 38.6668 16.9167V26.5833",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.96c43945c0d10a4bf7938a1e669b886e.svg";
export { ForwardRef as ReactComponent };